import { c as _c } from "react/compiler-runtime";
import { safeT } from '@/shared/localization';
import { useTranslations } from 'next-intl';
import { useMetadata } from './useMetaData';
export default function useAssetCategory() {
  const $ = _c(9);
  const t = useTranslations("meta");
  const {
    data: t0
  } = useMetadata();
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {
      product: {
        classKeys: []
      }
    } : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const meta = t1;
  let t2;
  if ($[2] !== meta.product.classKeys || $[3] !== t) {
    let t3;
    if ($[5] !== t) {
      t3 = category => ({
        id: category,
        title: safeT(t, `class_keys.${category}`, category)
      });
      $[5] = t;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = meta.product.classKeys.map(t3);
    $[2] = meta.product.classKeys;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const categories = t2;
  let t3;
  if ($[7] !== categories) {
    t3 = {
      categories
    };
    $[7] = categories;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}